import { FilterState } from "@/redux/filter.types";
import { createSelector } from "@reduxjs/toolkit";

const filterState = (state: { filter: FilterState }) => state;

export const selectFilter = createSelector(
  filterState,
  (state) => state.filter
);